import { render, staticRenderFns } from "./IndexUserMain.vue?vue&type=template&id=371d2d98&scoped=true&"
import script from "./IndexUserMain.vue?vue&type=script&lang=js&"
export * from "./IndexUserMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d2d98",
  null
  
)

export default component.exports